/**
 * Zufall wird in die Engine **injiziert**, nie importiert.
 *
 * Dadurch ist jeder Spielablauf mit einem geseedeten Generator exakt
 * reproduzierbar, während der Server produktiv eine kryptographische Quelle
 * einsetzt. Die Engine selbst bleibt deterministisch und damit testbar.
 */
export type Rng = () => number;

/** Kleiner, schneller PRNG für Tests. Gleicher Seed ⇒ gleiche Folge. */
export function mulberry32(seed: number): Rng {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Fisher-Yates. Liefert eine neue Liste, die Eingabe bleibt unberührt. */
export function shuffle<T>(items: readonly T[], rng: Rng): T[] {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    const a = result[i]!;
    const b = result[j]!;
    result[i] = b;
    result[j] = a;
  }
  return result;
}
